import utils from '@/utils';

// 导入当前文件夹下面所有文件
const componentFiles = require.context('./', true, /index\.vue$/);

// 解析导入的文件
const components = utils.resolveRequire(componentFiles, null, './', '/index.vue');

const SyComponents = {
    /**
     * 使用Vue.use时会调用此方法
     * @param vue
     * @param options
     */
    install(vue, options) {
        Object.keys(components).forEach(key => {
            const component = components[key];
            vue.component(component.name, component);
        });
    }
};

export default SyComponents;
